import { NbRoleProvider } from '@nebular/security';
import { BaseAuthenticatedComponent } from './../base-authenticated/base-authenticated.component';
import { BaseHmComponent } from './../base-hm/base-hm.component';
import { Component, Input, OnInit } from '@angular/core';
import { AuthUser } from '@hm_app/@core/models/auth_user';
import { InfoPagina } from '@hm_app/@core/models/info';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import * as _ from 'lodash-es';
import { Router, ActivatedRoute } from '@angular/router';
import { NbToastrService } from '@nebular/theme';

@Component({
    selector: 'hm-info-page',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
})
export class InfoComponent extends BaseAuthenticatedComponent {

    //public utente: AuthUser;

    public get label_info(): string {
        return this.current_info?.pagina;
    }

    @Input() public set label_info(value: string) {
        if (this.current_info?.pagina == value) {
            return;
        }

        this.hmService.getAll<InfoPagina>(InfoPagina, { pagina: value }).subscribe(info_pagina => {
            this.current_info = info_pagina[0];
            this.youtube_code = this.current_info?.youtube_code;
        });

    }


    current_info: InfoPagina;

    youtube_code: string;

    constructor(
        protected hmService: HappyMammaService,
        protected toastrService: NbToastrService,
        protected roleProvider: NbRoleProvider,
        protected route: ActivatedRoute,
        protected router: Router,
    ) {
        super(hmService, toastrService, roleProvider);
        /*this.hmService.auth_user$.subscribe(utente => {
           this.utente = utente;
          // console.log(utente)
           });*/
        //this.utente = this.hmService._auth_user;
    }

    async ngOnInit() {
        await super.ngOnInit();
        const tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);

        this.route.params.subscribe(params => {
            const pagina = params['label'];
            if (!pagina) {
                return
            }
            this.hmService.getAll<InfoPagina>(InfoPagina, { pagina: pagina }).subscribe(info_pagina => {
                this.current_info = info_pagina[0];
                this.youtube_code = this.current_info?.youtube_code;
            });
        });

    }
}
